import { render, staticRenderFns } from "./ShopeeIntegration.vue?vue&type=template&id=a2eaf088"
import script from "./ShopeeIntegration.vue?vue&type=script&lang=js"
export * from "./ShopeeIntegration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports